﻿<template>

    <div v-if="loading" class="sc-cal-loading" role="status" aria-live="polite">
        <p>
            <svg class="ts-spinner" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" opacity="0.25" /><path d="M22 12a10 10 0 0 0-10-10" stroke="currentColor" stroke-width="3" stroke-linecap="round" /></svg>
            Loading departures…
        </p>
        <div class="tc-cal-skeleton" aria-hidden="true"><span v-for="n in 35" :key="n"></span></div>
    </div>

    <div class="vc-weeks" :hidden="loading">
        <div class="grid">
            <div class="grid grid-cols-7 vc-weekday-heading">
                <div class="flex justify-center items-center vc-weekday">MON</div>
                <div class="flex justify-center items-center vc-weekday">TUE</div>
                <div class="flex justify-center items-center vc-weekday">WED</div>
                <div class="flex justify-center items-center vc-weekday">THU</div>
                <div class="flex justify-center items-center vc-weekday">FRI</div>
                <div class="flex justify-center items-center vc-weekday">SAT</div>
                <div class="flex justify-center items-center vc-weekday">SUN</div>
            </div>
            <div class="grid grid-cols-7 vc-weekday-row" v-for="week in capacity">
                <div class="flex justify-center items-center vc-day" v-for="day in week.days">
                    <calendar_day v-if="!day.is_today && !isAAT()" :day=day :selected_day="Is_Date_Selected(day)" @dateSelected="Date_Selected"></calendar_day>
                    <calendar_day v-if="isAAT()" :day=day :selected_day="Is_Date_Selected(day)" @dateSelected="Date_Selected"></calendar_day>
                </div>
            </div>
        </div>
    </div>

</template>

<script lang="ts" src="./calendar_details.ts"></script>